import { render, staticRenderFns } from "./ReaderAppUserDetail.vue?vue&type=template&id=17e97860"
import script from "./ReaderAppUserDetail.vue?vue&type=script&lang=js"
export * from "./ReaderAppUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports